import React, { memo, useCallback, useEffect } from 'react';
import { Field, useFormState } from 'react-final-form';
import { useNavigate } from 'react-router';
import { ThreeDots } from 'react-loader-spinner';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import CommonButton from '../../../components/common-button/CommonButton';
import CompanyForm from '../company-from/CompanyForm';
import AssignProjects from '../assign-projects/AssignProjects';
import CompanyUsers from '../company-users/CompanyUsers';
import CustomerUnsavedChangesModal from './customer-unsaved-changes/CustomerUnsavedChangesModal';
import scrollToFirstErrorField from '../../../utils/scrollToFirstErrorField';
import { removeUserFromCompanyCreate } from '../../../redux/customers/customersActions';
import AIFeatures from '../ai-features/AIFeatures';

import scss from './CustomerCreateFormInner.module.scss';

const CustomerCreateFormInner = ({ onSubmit }) => {
  const { t } = useTranslation('customers');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { submitting, errors, values } = useFormState();

  const handleRemoveAddedUsers = useCallback(() => {
    if (values.companyUsers && values.companyUsers.length) {
      dispatch(removeUserFromCompanyCreate({ id: values.companyUsers.map(({ id }) => id) }));
    }
  }, [dispatch, values]);

  const handleCancel = useCallback(() => {
    handleRemoveAddedUsers();
    navigate('/customers');
  }, [navigate, handleRemoveAddedUsers]);

  const handleSubmit = useCallback(() => {
    scrollToFirstErrorField(errors);
    onSubmit();
  }, [onSubmit, errors]);

  useEffect(() => {
    window.addEventListener('beforeunload', handleRemoveAddedUsers);

    return () => {
      window.removeEventListener('beforeunload', handleRemoveAddedUsers);
    };
  }, [handleRemoveAddedUsers]);

  return (
    <>
      <CompanyForm />
      <AssignProjects />
      <AIFeatures />

      <Field name='companyUsers' component={CompanyUsers} />

      <div className={scss.actions}>
        <CommonButton styleColor='secondary' type='button' onClick={handleCancel} maxWidth={120} disabled={submitting}>
          {t('cancel')}
        </CommonButton>

        <CommonButton styleColor='primary' type='submit' onClick={handleSubmit} maxWidth={120} disabled={submitting}>
          {submitting ? <ThreeDots height={15} width={40} /> : null}
          {t('save')}
        </CommonButton>
      </div>

      <CustomerUnsavedChangesModal onSubmit={onSubmit} onDontSave={handleRemoveAddedUsers} />
    </>
  );
};

export default memo(CustomerCreateFormInner);
